export const pennant = {
  msrp: 15.99,
  infoLink: 'https://www.teamtriton.com/custom-pennants.html',
  items: [
    {
      number: 'PF1',
      hasModel: false,
    },
    {
      number: 'PF2',
      hasModel: false,
    },
    {
      number: 'PF3',
      hasModel: false,
    },
    {
      number: 'PF4',
      hasModel: false,
    },
    {
      number: 'PF5',
      hasModel: false,
    },
    {
      number: 'PF6',
      hasModel: false,
    },
    {
      number: 'PF7',
      hasModel: false,
    },
    {
      number: 'PF8',
      hasModel: false,
    },
    {
      number: 'PF9',
      hasModel: false,
    },
    {
      number: 'PF10',
      hasModel: false,
    },
    {
      number: 'PF11',
      hasModel: false,
    },
    {
      number: 'PF12',
      hasModel: false,
    },
    {
      number: 'PF13',
      hasModel: false,
    },
    {
      number: 'PF14',
      hasModel: false,
    },
    {
      number: 'PF15',
      hasModel: false,
    },
  ],
};
